import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { lifecycle, withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon, SliderInput } from '../..';

const timeRange = [
  0,
  30,
  45,
  60,
  90,
  120,
  150,
  180,
  210,
  240,
  300,
  360,
  420,
  480,
  480 * 2,
  480 * 3,
  480 * 4,
  480 * 5,
]

export const mapTimeToLable = (time) => {
  const minutes = time % 60
  const minuteLabel = minutes ? `${minutes}m` : ''
  const hours = ((time % (8 * 60)) - minutes) / 60
  const hourLabel = hours ? `${hours}h` : ''
  const days = (time - hours * 60 - minutes) / (8 * 60)
  const dayLabel = days ? `${days}d` : ''
  return `${dayLabel} ${hourLabel} ${minuteLabel}`.trim()
}

const EventDurationFilter = ({
  onEventDurationChange,
  toggleFilter,
  showFilter,
  filter,
  refresh
}) => {
  const {
    min,
    max
  } = filter
  const minLabel = mapTimeToLable(timeRange[min])
  const maxLabel = mapTimeToLable(timeRange[max])

  return (
    <div className='filter content-length-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
            <span id='label'>Duration</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id="cpd-hour-filter" in={showFilter}>
          <form noValidate>
            <div className='bottom-gap'>
              <SliderInput
                key={refresh}
                onChange={onEventDurationChange}
                min={0}
                max={timeRange.length - 1}
                step={1}
                minLabel={minLabel}
                maxLabel={maxLabel} />
            </div>
          </form>
        </Collapse>
      </Row>
    </div>
  )
}

export default compose(
  withStateHandlers(
    {
      showFilter: false,
      filter: {
        min: 0,
        max: timeRange.length - 1
      },
      refresh: 0
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      }),
      setFilter: () => (filter) => ({ filter }),
      resetEventDuration: ({ refresh }, { eventDurationFilter }) => () => {
        const {
          min,
          max
        } = eventDurationFilter

        if (!min && !max) {
          return {
            filter: {
              min: 0,
              max: timeRange.length - 1
            },
            refresh: refresh + 1
          }
        } else {
          return {}
        }
      }
    }
  ),
  withHandlers({
    onEventDurationChange: ({ onChange, setFilter }) => (filter) => {
      const {
        min,
        max
      } = filter
      const parsed = {
        min: timeRange[min] / 60,
        max: timeRange[max] / 60
      }
      setFilter(filter);
      onChange(parsed);
    }
  }),
  lifecycle({
    componentDidUpdate(prevStat) {
      const { eventDurationFilter, resetEventDuration } = this.props
      if (!fp.isEqual(eventDurationFilter)(prevStat.eventDurationFilter)) {
        resetEventDuration(eventDurationFilter)
      }
    }
  })
)(EventDurationFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/event-duration-filter.js